// Angular
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/reducers';
import { Logout } from '@app/core/auth';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
// Transloco
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-logout-confirmation',
  templateUrl: './logout-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, TranslocoDirective]
})
export class LogoutConfirmationComponent {

  // Private
  private readonly store = inject<Store<AppState>>(Store);
  private readonly dialogRef = inject<MatDialogRef<LogoutConfirmationComponent>>(MatDialogRef);

  /**
   * On Logout
   * @memberof LogoutConfirmationComponent
   */
  onLogout() {
    this.store.dispatch(new Logout());
    this.dialogRef.close();
  }
}
